import type {
  ClientCountMetrics,
  FinancialMetrics,
  GetClientCountMetricsParams,
  GetFinancialMetricsParams,
  GetRelifDashboardMetricsParams,
  GetRevenueMetricsParams,
  RelifDashboardMetrics,
  RevenueMetrics,
} from '../types/relifDashboard';
import baseWorkloadApi from './baseWorkloadApi';

const relifDashboardApi = baseWorkloadApi.injectEndpoints({
  endpoints: (build) => ({
    getRelifDashboardMetrics: build.mutation({
      query: (params: GetRelifDashboardMetricsParams) => ({
        url: '/admin/relifDashboard/metrics',
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: RelifDashboardMetrics): RelifDashboardMetrics => response,
    }),
    getRevenueMetrics: build.mutation({
      query: (params: GetRevenueMetricsParams) => ({
        url: '/admin/relifDashboard/revenue',
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: RevenueMetrics): RevenueMetrics => response,
    }),
    getClientCountMetrics: build.mutation({
      query: (params: GetClientCountMetricsParams) => ({
        url: '/admin/relifDashboard/clients',
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: ClientCountMetrics): ClientCountMetrics => response,
    }),
    getFinancialMetrics: build.mutation({
      query: (params: GetFinancialMetricsParams) => ({
        url: '/admin/relifDashboard/financial',
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: FinancialMetrics): FinancialMetrics => response,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetRelifDashboardMetricsMutation,
  useGetRevenueMetricsMutation,
  useGetClientCountMetricsMutation,
  useGetFinancialMetricsMutation,
} = relifDashboardApi;
